export const STANDUP_DESCRIPTION =
  "Use AI to get an update about your team's progress. All task updates will be summarized.";
export const CHANGELOG_DESCRIPTION =
  "Use AI to summarize what your team has accomplished. Only completed tasks will be summarized.";
